export
const name: string = "HudColor";

export
const preproc: string = ``;

export
const declaration: string = `
    attribute vec3  a_position;

    uniform mat4    u_viewProjectionMatrix;
    uniform mat4    u_rotationMatrix;
    uniform mat4    u_modelMatrix;
`;

export
const varyings: string = ``;

export
const implementation: string = `
    void main()
    {
        gl_Position = u_viewProjectionMatrix * u_modelMatrix * u_rotationMatrix * vec4(a_position, 1.0);
    }
`;
